import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=ee3ab328&scoped=true&"
import script from "./SortIcon.vue?vue&type=script&lang=ts&"
export * from "./SortIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SortIcon.vue?vue&type=style&index=0&id=ee3ab328&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3ab328",
  null
  
)

export default component.exports